class CinematicCore {
    constructor() {
        this.mouse = { x: 0, y: 0 };
        this.windowWidth = window.innerWidth;
        this.windowHeight = window.innerHeight;
        this.isMobile = window.innerWidth <= 768;

        this.initEvents();
        this.initLoop();
    }

    initEvents() {
        // track mouse - only on desktop
        window.addEventListener('mousemove', (e) => {
            if (this.isMobile) return; // Skip parallax on mobile
            
            this.mouse.x = (e.clientX / this.windowWidth) - 0.5; // -0.5 to 0.5
            this.mouse.y = (e.clientY / this.windowHeight) - 0.5;

            // Update CSS variables for CSS-only effects
            document.documentElement.style.setProperty('--mouse-x', this.mouse.x);
            document.documentElement.style.setProperty('--mouse-y', this.mouse.y);
        });

        window.addEventListener('resize', () => {
            this.windowWidth = window.innerWidth;
            this.windowHeight = window.innerHeight;
            this.isMobile = window.innerWidth <= 768;
        });
    }

    initLoop() {
        // RAF Loop for smoother physics if needed
        requestAnimationFrame(() => this.render());
    }

    render() {
        // Skip parallax on mobile
        if (this.isMobile) {
            requestAnimationFrame(() => this.render());
            return;
        }
        
        // Parallax Logic
        const parallaxItems = document.querySelectorAll('[data-parallax-depth]');

        parallaxItems.forEach(item => {
            const depth = parseFloat(item.getAttribute('data-parallax-depth')) || 10;
            const x = this.mouse.x * depth;
            const y = this.mouse.y * depth;

            item.style.transform = `translate3d(${x}px, ${y}px, 0)`;
        });

        requestAnimationFrame(() => this.render());
    }
}

document.addEventListener('DOMContentLoaded', () => {
    window.cinematicCore = new CinematicCore();
    console.log('Cinematic Core Online');
});
